import styled from 'styled-components';
import { PageHead, PageSubhead } from 'next/components/ui';

export const IdentifiersListSection = styled.div`
  display: flex;
`;

export const IdentifierListItem = styled.div`
  display: flex;
  margin-right: 15px;
`;

export const IdentifierName = styled.span`
  font-size: var(--regular);
  line-height: 150%;
`;

export const IdentifierValue = styled(IdentifierName)`
  font-weight: var(--normal);
  margin-left: 5px;
`;

export const IdentifierText = styled.span``;

export const ProfileHeader = styled(PageHead)`
  height: 100px;
  padding-bottom: 16px;
  padding-top: 16px;

  ${PageSubhead} {
    padding-top: 0px;
    color: var(--sharkbait-ooh-la-la);
  }
`;
